import React, { useState, useEffect } from "react";
import axios from "axios";
import { MdMan, MdWoman } from "react-icons/md";
import "./home.css";
import "./responsive.css";
// import Select from "react-select";
import { Button, Modal } from "react-bootstrap";
import NoDataImage from "../../background.gif";
import { Link } from "react-router-dom";
import MemberPhotoSlider from "../common/MemberPhotoSlider";
import { getUserImages } from "../../utils/userImages";

export default function Bnner() {
  // for form caste
  // caste data
  const [casteOptions, setCasteOptions] = useState([]);

  // for form caste

  //  bg image
  const [bgImage, setBgImage] = useState(null);
  const [imageLoadError, setImageLoadError] = useState(false);

  const [formData, setFormData] = useState({
    gender: "male",
    // lookingFor: "female",
    religion: "Hindu",
    caste: "Select Caste",
    minAge: 21,
    maxAge: 60,
  });

  const [apiData, setApiData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpenModal, setOpenModal] = useState(false);

  const handleModal = () => {
    setOpenModal(!isOpenModal);
  }


  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/caste.php`
      )
      .then((response) => {
        if (Array.isArray(response.data.data.caste)) {
          setCasteOptions(response.data.data.caste);
        } else {
          console.error("Unexpected caste data format:", response.data);
          setCasteOptions([]);
        }


      })
      .catch((error) => {
        console.error("Error fetching caste data:", error);
      });

    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/banner-image.php`
      )
      .then((response) => {
        if (response.data.banner_image) {
          // Verify the image exists before setting it
          const img = new Image();
          img.onload = () => {
            setBgImage(response.data.banner_image);
            setImageLoadError(false);
          };
          img.onerror = () => {
            console.error("Image failed to load:", response.data.banner_image);
            setImageLoadError(true);
          };
          img.src = response.data.banner_image;
        }
        const imageURL = process.env.REACT_APP_API_BASE_URL + response.data.banner_image;
        setBgImage(imageURL);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setImageLoadError(true);
      });
    setIsLoading(false);
  }, [formData, apiData]);

  //  bg image

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Calculate age from DOB
  const calculateAge = (dob) => {
    if (!dob) return "N/A";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  // Format height (5.6 => 5'6")
  const formatHeight = (height) => {
    if (!height) return "N/A";
    const [feet, inches] = height.split(".");
    return `${feet}'${inches}"`;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);


    const payload = new FormData();
    payload.append("gender", formData.gender);
    payload.append("age", formData.maxAge);
    payload.append("caste", formData.caste);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}mycon/recently_joint_search`, payload
      );
      if (response.data.users) setApiData(response.data);
      // else setApiData({});
      handleModal();
    } catch (error) {
      console.error("There was an error fetching users!", error);
    } finally {
      setLoading(false);
    }
    setLoading(false);

  };


  return (

    <>
      {isLoading && <div className='custom-loader-g'>
        <div class="spinner-border text-danger" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>}


      <div>
        <section className="bg-img">
          <div className="str">
            <div
              className="hom-head"
              style={{
                backgroundImage: `url('${bgImage}')`,
                backgroundSize: "cover",
                backgroundPosition: "center top",
                backgroundColor: "#f5f5f5",
                backgroundRepeat: "no-repeat",
                position: "relative",
              }}
            >
              {/* Dark overlay for better text visibility */}
              {/* {bgImage && !imageLoadError && ( */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0,0,0,.1)",

                }}
              ></div>
              {/* )} */}

              <div
                className="container"
                style={{ position: "relative", zIndex: 1 }}
              >
                <div className="row">
                  <div className="hom-ban">
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div className="banner-content">
                          <h1 style={{ textShadow: "#000 1px 0 10px" }} className="text-white fw-bold">
                            Your Journey To Love Begins{" "}
                            <span style={{ textShadow: "#fff 1px 0 10px", color: "#F4B818", fontWeight: "bold" }}>here !</span>
                          </h1>

                          <h3 className="text-white fw-bold banner-sub" style={{ textShadow: "#000 1px 0 10px" }}>
                            Connect With Genuine Matches Who Share Your{" "}
                            <span style={{ textShadow: "#fff 1px 0 10px", color: "#F4B818", fontWeight: "bold" }}>values</span> and{" "}
                            <span style={{ textShadow: "#fff 1px 0 10px", color: "#F4B818", fontWeight: "bold" }}>dreams.</span>
                          </h3>

                          {apiData.users && (
                            <div
                              className="api-response"
                              style={{
                                marginTop: "20px",
                                padding: "10px",
                                backgroundColor: "rgba(255,255,255,0.2)",
                                borderRadius: "5px",
                              }}
                            >
                              <p className="mb-0 alert alert-danger" style={{ color: 'rgb(255, 255, 255)', background: '#e53d5c' }}>
                                Success! {apiData.message}
                              </p>
                            </div>
                          )}

                          {error && (
                            <div
                              className="error-message"
                              style={{
                                marginTop: "20px",
                                padding: "10px",
                                backgroundColor: "rgba(255,0,0,0.2)",
                                borderRadius: "5px",
                              }}
                            >
                              <p style={{ color: "#fff" }}>Error: {error}</p>
                            </div>
                          )}

                          {/* Image load error message (debugging only) */}
                          {imageLoadError && (
                            <div style={{ color: "black", marginTop: "10px" }}>
                              {/* Banner image failed to load/ */}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div className="wedding-form-container">
                          <div className="wedding-form">
                            <form onSubmit={handleSubmit}>
                              {/* Form sections remain exactly the same */}
                              {/* I'm A section */}
                              <label className="form-label">I'm</label>
                              <div className="form-section">
                                <div className="gender-options">
                                  <label
                                    className={`gender-option ${formData.gender === "male" ? "selected" : ""
                                      }`}
                                  >
                                    <input
                                      type="radio"
                                      name="gender"
                                      value="male"
                                      checked={formData.gender === "male"}
                                      onChange={handleChange}
                                      className="hidden-radio"
                                    />
                                    <MdMan className="gender-icon" /> Male
                                  </label>
                                  <label
                                    className={`gender-option ${formData.gender === "female"
                                      ? "selected"
                                      : ""
                                      }`}
                                  >
                                    <input
                                      type="radio"
                                      name="gender"
                                      value="female"
                                      checked={formData.gender === "female"}
                                      onChange={handleChange}
                                      className="hidden-radio"
                                    />
                                    <MdWoman className="gender-icon" /> Female
                                  </label>
                                </div>
                              </div>



                              {/* Religion and Caste — always one row */}
                              <div className="banner-filter-row">
                                <div className="form-section px-0 banner-filter-col">
                                  <label className="form-label">Religion</label>
                                  <input
                                    name="religion"
                                    type="text"
                                    value={formData.religion}
                                    readOnly
                                    className={`form-control ${formData.religion}`}
                                  />
                                </div>
                                <div className="form-section px-0 banner-filter-col">
                                  <label className="form-label">Caste</label>
                                  <select
                                    required
                                    name="caste"
                                    value={formData.caste}
                                    onChange={handleChange}
                                    className={`form-select w-100 ${formData.caste &&
                                      formData.caste !== "Select Caste"
                                      ? "selected"
                                      : ""
                                      }`}
                                  >
                                    <option value="">Select Caste</option>
                                    {casteOptions.map((caste, index) => (
                                      <option key={index} value={caste}>
                                        {caste}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              {/* Age Range */}
                              <div className="form-section age-meter">
                                <div className="age-meter-head">
                                  <label className="form-label mb-0">Of Age Around</label>
                                  <span className="age-meter-value">
                                    {formData.minAge} – {formData.maxAge} yrs
                                  </span>
                                </div>
                                <div className="age-meter-slider">
                                  <div
                                    className="age-meter-fill"
                                    style={{
                                      width: `${((formData.maxAge - 21) / (60 - 21)) * 100}%`,
                                    }}
                                  />
                                  <input
                                    type="range"
                                    min="21"
                                    max="60"
                                    step="1"
                                    value={formData.maxAge}
                                    onChange={(e) =>
                                      setFormData((prev) => ({
                                        ...prev,
                                        minAge: 21,
                                        maxAge: Math.max(21, parseInt(e.target.value, 10) || 21),
                                      }))
                                    }
                                    className="age-meter-input"
                                    aria-label="Maximum age"
                                  />
                                </div>
                                <div className="age-marks">
                                  <span>21</span>
                                  <span>30</span>
                                  <span>40</span>
                                  <span>50</span>
                                  <span>60</span>
                                </div>
                              </div>

                              <button
                                type="submit"
                                className="submit-button"
                                disabled={loading}
                              >
                                {loading
                                  ? "Searching..."
                                  : "Start Your Search Today!"}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>







      <Modal backdrop="static" aria-labelledby="contained-modal-title-vcenter"
        centered keyboard={false} show={isOpenModal} size="xl" onHide={handleModal}>
        <Modal.Body >

          <div className="row">




            {(!apiData.users) ? (<div className='position-relative nodataBox w-100 h-100' style={{ backgroundImage: `url(${NoDataImage})` }}><div><h2 className={'text-white fw-bold text-center'}>No Match Found</h2>
              <Button onClick={handleModal} className="btn btn-light mx-auto d-block">Search Again</Button>
            </div>

            </div>) : ""}

            {(apiData?.users) ? apiData?.users?.map(member => (
              <Link to={`/login`} key={member.user_id} className="col-md-4 my-2">
                <div className="overflow-hidden" style={{ borderRadius: "10px" }}>
                  <div className="member-photo">
                    <MemberPhotoSlider
                      images={getUserImages(member)}
                      alt={member.name}
                      imageClassName="member-image"
                    />
                  </div>
                  <div className="member-info">
                    <h5> {member.name}</h5>
                    <div className="member-id-gender">
                      <span className="member-id">
                        {member.gender === "male"
                          ? "M"
                          : member.gender === "female"
                            ? "F"
                            : ""}
                      </span>
                      <span className="member-id">HS{member.user_id}</span>
                    </div>

                    <div className="member-details" >
                      <div className="detail-row">
                        <span className="detail-label">Age:</span>
                        <span className="detail-value">
                          {calculateAge(member.dob)} Yrs
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Height:</span>
                        <span className="detail-value">
                          {formatHeight(member.height)}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Gender:</span>
                        <span className="detail-value">
                          {member.gender}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Caste:</span>
                        <span className="detail-value">
                          {member.caste || "N/A"}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Location:</span>
                        <span className="detail-value">
                          {member.curr_location || member.country || "India"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            )) : ("")}

          </div>
        </Modal.Body>
      </Modal>

    </>
  );
}
